const singleLegs: string[] = ["Commercial", "Charter", "Comm OBC - Single Leg"];
const multipleLegs: string[] = ["CharterComm", "CommCharter"];
const charterLegs: string[] = ['Charter', 'CharterComm', 'CommCharter'];

export {singleLegs,multipleLegs,charterLegs};